"use client";

import useViewType from "@/utils/Hooks/useViewType";
export default function SectionSkinBackground({
  children
}: {
  children: React.ReactNode;
}) {
  const isMobile = useViewType();
  return <div style={{
    backgroundColor: isMobile ? "#FFFAF1" : "transparent"
  }} data-sentry-component="SectionSkinBackground" data-sentry-source-file="SectionSkinBackground.tsx">
      {children}
    </div>;
}